export default __webpack_public_path__ + "static/media/MiniTape_SideA_04_Telefonbeantworter-Bani.194fd60e.mp3";